import {travelAllowanceApi} from "@services/api.service";

import {RideDocumentType} from "@enums/travelAllowance/rideDocument";

const getRideDocumentPdfByType = async (rideReportId: number, type: RideDocumentType): Promise<any> => {
    const response: any = await travelAllowanceApi.get(`ride-documents/ride-report/${rideReportId}/generate/${type.toLowerCase().replace(/_/g, '-')}`, {
        responseType: "blob"
    });

    return response.data;
}

const getRideDocumentContentByType = async (rideReportId: number, type: RideDocumentType): Promise<any> => {
    const response: any = await travelAllowanceApi.get(`ride-documents/ride-report/${rideReportId}/${type.toLowerCase().replace(/_/g, '-')}/content`);

    return response.data;
}

export {
    getRideDocumentPdfByType,
    getRideDocumentContentByType
};
